<template>
  <div>
    <PageHeader/>

      <div v-bind:class="headerClass">
        <div class="kuiu-anchorage-image-container">
          <img v-if="getSubscription === 'specialsauce' && !isSuccessPage" class="special-sauce-image" src="../assets/images/goodlife_logo.png">
          <img v-if="getSubscription === 'kuiuanchorage' && !isSuccessPage" class="kuiu-anchorage-image" src="../assets/images/anchorage_logo.png">
          <span>{{pageTitleText}}</span>
        </div>
        <div v-if="pageTitleSubtext && !isSuccessPage" v-bind:class="subtextClass" >{{pageTitleSubtext}}</div>
        <div v-if="getSubscription === 'kuiuanchorage' && isSuccessPage" class="success-page-subtext">DOWNLOAD THE APP</div>
      </div>



    <h2 v-if="busy">loading...</h2>

    <component v-bind:is="currentView" @success="setView" @login="routeLogin" @register="routeZipAndAge"/>


  </div>
</template>

<script>
  import store from '../lib/store';
  import PageHeader from '../components/helpers/PageHeader';
  import Start from '../components/start/Start';
  import Login from '../components/start/Login';
  import ZipAndAge from '../components/start/ZipAndAge';
  import Steps from '../components/StepsQuick';
  import Subscriber from '../components/helpers/Subscriber';
  import SuccessSpecialSauce from '../components/success/SuccessSpecialSauce';
  import SuccessKUIUAnchorage from '../components/success/SuccessKUIUAnchorage';

  export default {
    name: 'Home',
    components: {
      PageHeader,
      Start,
      Login,
      ZipAndAge,
      Steps,
      Subscriber,
      SuccessSpecialSauce,
      SuccessKUIUAnchorage,
    },
    data() {
      return {
        busy: false,
        currentView: 'Start',
      };
    },
    methods: {
      setView() {
        let res;
        switch (this.currentView) {
          case 'Start':
            if (store.get('authToken')) {
              res = 'Steps';
            } else {
              res = 'ZipAndAge';
            }
            break;
          case 'ZipAndAge':
            res = 'Steps';
            break;
          case 'Login':
            res = 'Steps';
            break;
          case 'Steps':
            res = 'Subscriber';
            break;
          case 'Subscriber':
            res = this.chooseSuccessPage();
            break;
          default:
          // do nothing
        }
        this.currentView = res;
      },
      chooseSuccessPage() {
        let res;
        switch (store.get('subscription')) {
          case 'kuiuanchorage':
            res = 'SuccessKUIUAnchorage';
            break;
          case 'specialsauce':
            res = 'SuccessSpecialSauce';
            break;
          default:
          // do nothing
        }
        return res;
      },
      routeLogin() {
        this.currentView = 'Login';
      },
      routeZipAndAge() {
        this.currentView = 'ZipAndAge';
      },
    },
    computed: {
      pageTitleText() {
        if (this.currentView.includes('Success')) {
          return store.get('title_success');
        }
        return store.get('title_in_progress');
      },
      getSubscription() {
        return store.get('subscription');
      },
      pageTitleSubtext() {
        const subtext = store.get('title_subtext');
        if (subtext) {
          return subtext;
        }
        return false;
      },
      isSuccessPage() {
        return this.currentView.includes('Success');
      },
      headerClass() {
        return this.getSubscription === 'kuiuanchorage' ? 'title-text text-center responsive dark-header' : 'title-text text-center responsive';
      },
      subtextClass() {
        return this.getSubscription === 'kuiuanchorage' ? 'text-center responsive subtext-lg kuiu-anchorage-subtext' : 'text-center responsive subtext-lg special-sauce-subtext';
      },
    },
  };
</script>

<style scoped>
  .title-text{
    font-size: 24px;
    margin-bottom: 20px;
  }
  .special-sauce-image {
    height: 80px;
    margin-bottom: -45px;
    width: auto;
    margin-right: 25px;
  }
  .kuiu-anchorage-image {
    height: 80px;
    margin-bottom: -45px;
    width: auto;
    margin-right: 25px;
  }
  .kuiu-anchorage-image-container {
    margin-bottom: 40px;
  }
  .kuiu-anchorage-subtext {
    color: white;
    font-size: 15px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .special-sauce-subtext {
    margin-top: -30px;
  }
  .success-page-subtext {
    font-size:24px;
  }
  .dark-header {
    background-color: rgba(1,1,1,.6);
    color: white;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media screen and (max-width: 35.5em) {
    .kuiu-anchorage-image {
      width: 90%;
      height: auto;
      margin: 0 0 0 0;
    }
    .special-sauce-image {
      width: 90%;
      height: auto;
      margin: 0 0 0 0;
    }
    .special-sauce-subtext {
      margin-top: 0;
    }
    .kuiu-anchorage-image-container {
      margin-bottom: 10px;
    }
    .kuiu-anchorage-subtext {
      margin-left: 0;
    }
    .success-page-subtext {
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// HomeQuick.vue?f1618c36